import React, { useState } from "react";
import "../../styles/TextField.css"; // Custom CSS file for styling
import eyeIcon from "../../assets/eye_icon.svg";


const TextField = ({
  type = "text",
  validate,
  errorMessage,
  value: externalValue,
  onChange: externalOnChange,
  onValidation,
  showError = true,
  isDisabled = false,
  notEditable = false,
}) => {

  const [internalValue, setInternalValue] = useState("");
  const [error, setError] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const value = externalValue !== undefined ? externalValue : internalValue;

  const handleChange = (e) => {
    const inputValue = e.target.value;
    if (externalOnChange) {
      externalOnChange(inputValue);
    } else {
      setInternalValue(inputValue);
    }
    if (validate) {
      const validationError = validate(inputValue);
      setError(validationError);
      if (onValidation) {
        onValidation(!validationError);
      }
    }
  };

  const handleBlur = () => {
    if (validate) {
      setError(validate(value));
    }
  };

  return (
    <div>
      <div className="textfield-outer-container">
        <input className={`input-text-field ${notEditable ? "not-editable" : ""}`} type={isPasswordVisible ? "text" : type} onChange={handleChange} onBlur={handleBlur} value={value} disabled={isDisabled}/>
        {type === "password" && (<img className="eye" src={eyeIcon} alt="icon" onClick={togglePasswordVisibility}/>)}
      </div>
      {showError && error && (
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            marginTop: "2px",
            textAlign: "left",
            width: "13rem"
          }}
        >
          <span style={{ color: "red", fontSize: "14px" }}>
            {errorMessage || error}
          </span>
        </div>
      )}
    </div>
  );
};

export default TextField;